<template>
  <multiselect
    v-model="selectedValue"
    :options="driverList"
    :multiple="true"
    :searchable="true"
    :show-labels="false"
    :allowEmpty="true"
    :maxHeight="240"
    label="nameSurname"
    track-by="id"
    class="w-auto min-w-250p"
    :placeholder="$t('flexigo.otp.allDrivers')"
    @input="handleChange"
  >
    <span slot="noOptions">
      {{ $t('flexigo.otp.noDataAvailable') }}
    </span>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';

export default {
  name: 'OtpDriverFilter',
  components: {
    Multiselect,
  },
  props: {
    selectedDrivers: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      selectedValue: null,
      driverList: [],
    };
  },
  computed: {
    ...mapGetters('otpDashboard', ['filteredAvailableDrivers']),
  },
  watch: {
    selectedDrivers(newVal) {
      this.selectedValue = newVal;
    },
    filteredAvailableDrivers: {
      handler(drivers) {
        this.driverList = this.formatDriverList(drivers);
      },
      immediate: true,
    },
  },
  mounted() {
    // Drivers are now fetched by parent component
  },
  methods: {
    formatDriverList(drivers = []) {
      if (!Array.isArray(drivers)) return [];
      return drivers.map((driver) => ({
        ...driver,
        nameSurname: driver.name || '',
      }));
    },
    handleChange() {
      this.$emit('change', this.selectedValue);
    },
  },
};
</script>

<style scoped>
.otp-driver-filter {
  width: 100%;
}
</style>
